// extracted by mini-css-extract-plugin
export default {"cls1":"t9vJRFWdSUHSm6_zVHlc","cls2":"mfTdNkclx8aGwCoKwQLb t9vJRFWdSUHSm6_zVHlc","isTabletDown":"IqE435c83TPfBz10ORIq","isDesktopUp":"YFyq57eMo1pyRr7ghx2L"};